/**
 * 0〜array_length-1までの配列作成。
 * @param arrayLength
 * @returns
 */
export function makeAryByLength(arrayLength: number): number[] {
  return [...Array(arrayLength).keys()];
}

/**
 * start_value〜end_valueまでの配列作成。
 * @param startValue 開始値
 * @param endValue 終了値
 * @returns
 */
export function makeAryByStartEnd(startValue: number, endValue: number): number[] | undefined {
  if ( startValue <= endValue ) {
    return [...Array(endValue - startValue + 1).keys()].map( v => startValue + v);
  } else if ( startValue > endValue ) {
    return [...Array(startValue - endValue + 1).keys()].map( v => startValue - v);
  }
}
